
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { cn } from '@/lib/utils';

interface CardGridProps {
  items: Array<{
    id: string;
    icon: React.ReactNode;
    title: string;
    description: string;
    className?: string;
  }>;
  className?: string;
  itemClassName?: string;
  cols?: 1 | 2 | 3 | 4;
  darkMode?: boolean;
}

const CardGrid = ({ 
  items, 
  className, 
  itemClassName,
  cols = 3,
  darkMode = false
}: CardGridProps) => {
  const colsClass = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-3",
    4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
  };

  return (
    <div className={cn(
      `grid gap-8`,
      colsClass[cols],
      className
    )}>
      {items.map((item, index) => (
        <Card 
          key={item.id} 
          className={cn(
            "p-8 border glass-effect card-hover", 
            darkMode ? "border-gray-700 bg-gray-800/60" : "border-border",
            itemClassName,
            item.className
          )}
        >
          <div className="mb-6 p-4 rounded-full bg-primary/10 inline-block">
            {item.icon}
          </div>
          <CardContent className="p-0">
            <h3 className={cn(
              "text-xl font-bold mb-3",
              darkMode && "text-white"
            )}>
              {item.title}
            </h3>
            <p className={cn(
              "text-foreground/80",
              darkMode && "text-white/80"
            )}>
              {item.description}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default CardGrid;
